import { CONFIG_ITEM_KEYS } from '../../../prebuilt/config-items/config-item-keys';

export const configItemUsesRovo = (configItemKey?: CONFIG_ITEM_KEYS): boolean => {
	if (!configItemKey) {
		return false;
	}

	switch (configItemKey) {
		case CONFIG_ITEM_KEYS.FREE_GENERATE:
		case CONFIG_ITEM_KEYS.FREE_GENERATE_AIFC:
			return true;
		default:
			return false;
	}
};

export const configItemUsesFreeGen = (configItemKey?: CONFIG_ITEM_KEYS): boolean => {
	if (!configItemKey) {
		return false;
	}

	switch (configItemKey) {
		case CONFIG_ITEM_KEYS.FREE_GENERATE:
			return true;
		default:
			return false;
	}
};
